// import _ from 'lodash';
// import { addLocaleData } from 'react-intl';



import {
    default as actions,
    langKey,
    defaultMessages,
    SWITCH_LANGUAGE
} from './action';


// 默认状态
const intlInitialState = {
    // 当前语言
    langKey,
    // 多语言数据
    messages: defaultMessages
};

// 注入语言数据
// Object.keys(defaultState.langs).forEach(lang => {
//     addLocaleData(Languages[lang].localeData);
// });

// Reducer
const reducer = (state = intlInitialState, action) => {
    switch (action.type) {
        case SWITCH_LANGUAGE:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export default {
    reducer,
    actions,
    intlInitialState
};